module.exports = __webpack_public_path__ + "img/e2e-x14md.prt.0639275d.jpg";